// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__26b69","footer":"ChangeClinic_footer__3SUDc"};